module.exports = "<main class=\"popups error\" align=\"center\">\n  <h2 class=\"capitalize\">Information</h2>\n  <br>\n\n  <h4>{{information}}</h4>\n  <br>\n  <button type=\"button\" class=\"btn btn-sm btn-popups capitalize\" style=\"width:150px\" (click)=\"closeModal()\">close\n  </button>\n</main>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/achelos-iot/modals/info-modal/info-modal.component.html
// module id = ./src/app/achelos-iot/modals/info-modal/info-modal.component.html
// module chunks = main